var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFooterLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.75 0H17.25C17.6625 0 18 0.3375 18 0.75V17.25C18 17.6625 17.6625 18 17.25 18H0.75C0.3375 18 0 17.6625 0 17.25V0.75C0 0.3375 0.3375 0 0.75 0ZM2.6625 15.3375H5.325V6.75H2.6625V15.3375ZM4.0125 5.5875C3.15 5.5875 2.475 4.9125 2.475 4.05C2.475 3.1875 3.15 2.5125 4.0125 2.5125C4.875 2.5125 5.55 3.1875 5.55 4.05C5.55 4.875 4.875 5.5875 4.0125 5.5875ZM12.675 15.3375H15.3V10.6125C15.3 8.2875 14.8125 6.525 12.1125 6.525C10.8375 6.525 9.9375 7.2375 9.6 7.9125H9.5625V6.75H7.0125V15.3375H9.675V11.1C9.675 9.975 9.9 8.8875 11.2875 8.8875C12.675 8.8875 12.675 10.1625 12.675 11.175V15.3375Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterLinkedin);
export default __webpack_public_path__ + "static/media/footer-linkedin.8d4b41d34db0d60e1dca4fd21e792a88.svg";
export { ForwardRef as ReactComponent };